<form [formGroup]="form" class="formgrid grid">
    <div class="field col-12">
        <label for="companyNameInput"
          >Firmenname<ow-validation-mark [control]="form.controls.companyName"></ow-validation-mark
        ></label>
        <input type="text" pInputText id="companyNameInput" formControlName="companyName" class="w-full" />
      </div>
      <div class="field col-12">
        <label for="invoiceStreetAddressInput"
          >Straße und Hausnummer<ow-validation-mark [control]="form.controls.invoiceStreetAddress"></ow-validation-mark
        ></label>
        <input type="text" pInputText id="invoiceStreetAddressInput" formControlName="invoiceStreetAddress" class="w-full" />
      </div>
      <div class="field col-12">
        <label for="invoicePostalCodeInput"
          >PLZ<ow-validation-mark [control]="form.controls.invoicePostalCode"></ow-validation-mark
        ></label>
        <input type="text" pInputText id="invoicePostalCodeInput" formControlName="invoicePostalCode" class="w-full" />
      </div>
      <div class="field col-12">
        <label for="invoiceCityInput"
          >Ort<ow-validation-mark [control]="form.controls.invoiceCity"></ow-validation-mark
        ></label>
        <input type="text" pInputText id="invoiceCityInput" formControlName="invoiceCity" class="w-full" />
      </div>
      <div class="field col-12">
        <label for="contactEmailInput">E-Mail-Adresse<ow-validation-mark [control]="form.controls.contactEmail"></ow-validation-mark></label>
        <input type="text" pInputText id="contactEmailInput" formControlName="contactEmail" class="w-full" />
      </div>
      <div class="field col-12">
        <label for="contactEmailConfirmationInput"
          >E-Mail-Adresse bestätigen<ow-validation-mark [control]="form.controls.contactEmailConfirmation"></ow-validation-mark
        ></label>
        <input type="text" pInputText id="contactEmailConfirmationInput" formControlName="contactEmailConfirmation" class="w-full" />
      </div>
      <div class="field col-12">
        <label for="invoiceAgreementNumberInput"
          >Steuernummer<ow-validation-mark [control]="form.controls.invoiceAgreementNumber"></ow-validation-mark
        ></label>
        <input type="text" pInputText id="invoiceAgreementNumberInput" formControlName="invoiceAgreementNumber" class="w-full" />
      </div>
      <div class="field col-12">
        <label for="invoiceReferenceInput"
          >Umsatzsteuer-ID
        </label>
        <input type="text" pInputText id="invoiceReferenceInput" formControlName="invoiceReference" class="w-full" />
      </div>
</form>
